/**
 * El aviso de moneda.
 *
 * POR QUE ESTE AVISO ES DISTINTO DE TODOS LOS DEMAS DE TORA
 * --------------------------------------------------------
 * Todo lo demas que puede salir mal en esta pantalla se nota: un producto
 * matcheado contra otro deja un nombre raro, un costo con un cero de mas deja un
 * precio absurdo que alguien ve el mismo dia.
 *
 * La moneda equivocada NO se nota. Un iPhone de US$ 900 cargado como $ 900
 * queda con precio de venta de $ 1.200 y se vende. El sistema no tiene forma de
 * saber que esta mal: el numero es valido, el producto existe, el margen se
 * calcula. Se descubre cuando cierra el mes.
 *
 * Por eso el aviso ocupa lugar, va arriba de la tabla y no se puede cerrar. No
 * bloquea —hay proveedores que mandan una lista en pesos por excepcion— pero
 * obliga a pasarle por encima a proposito.
 */
import type { ReactNode } from "react";
import { TriangleAlert } from "lucide-react";

import { Aviso } from "@/components/ui/aviso";

import type { AlertaMoneda } from "./logica";

export function AvisoMoneda({
  alerta,
  accion,
  className,
}: {
  alerta: AlertaMoneda | null;
  /** Que hacer al respecto ("Elegir otro proveedor"), debajo del detalle. */
  accion?: ReactNode;
  className?: string;
}): JSX.Element | null {
  if (alerta === null) return null;
  const grave = alerta.nivel === "GRAVE";

  // Grave interrumpe (`role="alert"`, lo pone Aviso por el tono); el aviso a
  // secas se anuncia cuando el lector llega. El triangulo va en los dos: es la
  // misma senal en distinto volumen.
  return (
    <Aviso
      tono={grave ? "destructive" : "warning"}
      icono={TriangleAlert}
      titulo={alerta.titulo}
      accion={accion}
      className={className}
    >
      {alerta.detalle}
    </Aviso>
  );
}
